module.exports = __webpack_public_path__ + "static/media/vn.66a12127.webp";